import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {ERROR_PARAM, RouterService} from '@npck/libs/commons';
import {AuthHolderService} from '../../domain/auth-holder.service';
import {Path} from '../../path';
import {Error} from '../app-error-handler.service';

export const emptyConsentDataGuard: CanActivateFn = (): boolean => {
    if (!inject(AuthHolderService).consentData) {
        inject(RouterService).navigate(Path.ERROR, {queryParams: {[ERROR_PARAM]: Error.INVALID_LINK}});
        return false;
    }
    return true;
};

export const emptyAuthSessionDataGuard: CanActivateFn = (): boolean => {
    if (!inject(AuthHolderService).authSessionData) {
        inject(RouterService).navigate(Path.ERROR, {queryParams: {[ERROR_PARAM]: Error.INVALID_LINK}});
        return false;
    }
    return true;
};
